import { useDropzone } from 'react-dropzone';
import { FaCloudUploadAlt, FaTimes, FaFileAlt } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 ARCHIVOS — react-dropzone

    ⚠️ La ventaja de dropzone: es un HOOK, no un componente. No trae CSS
       propio ni markup, así que la caja de arrastre la dibujamos nosotros
       y queda 100% con tus tokens. Cero neutralización.
*/

const onFormatSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / 1048576).toFixed(1)} MB`;
};

export const FieldFile = ({
    id, label, hint, error,
    files = [], onChange,
    accept = null, maxFiles = 0, maxSize = 5242880,
    dropText = 'Arrastrá archivos o hacé clic para elegir',
    isDisabled = false, isRequired = false,
    span = 2,
}) => {

    const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
        accept: accept ?? undefined,
        maxFiles: maxFiles || undefined,
        maxSize,
        disabled: isDisabled,
        onDrop: (accepted) => onChange?.([...files, ...accepted]),
    });

    const onRemove = (index) => onChange?.(files.filter((_, i) => i !== index));

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} error={error} span={span}
            isRequired={isRequired} isDisabled={isDisabled}
            hint={hint ?? `Hasta ${onFormatSize(maxSize)} por archivo`} >

            <div {...getRootProps({ className: `${BLOCK}__drop` })}
                data-active={isDragActive} data-reject={isDragReject} >

                <input id={DOM_ID} {...getInputProps()} />

                <FaCloudUploadAlt className={`${BLOCK}__drop_icon`} aria-hidden="true" />

                <p className={`${BLOCK}__drop_text`}>
                    {isDragActive ? 'Soltá acá' : dropText}
                </p>

            </div>

            {
                files.length > 0 && (
                    <ul className={`${BLOCK}__file_list`}>
                        {
                            files.map((file, index) => (
                                <li key={`${file.name}_${index}`} className={`${BLOCK}__file`}>

                                    <FaFileAlt className={`${BLOCK}__file_icon`} aria-hidden="true" />

                                    <span className={`${BLOCK}__file_name`}>{file.name}</span>

                                    <span className={`${BLOCK}__file_size`}>{onFormatSize(file.size)}</span>

                                    <button type="button" className={`${BLOCK}__file_remove`}
                                        aria-label={`Quitar ${file.name}`}
                                        onClick={() => onRemove(index)} disabled={isDisabled} >
                                        <FaTimes />
                                    </button>

                                </li>
                            ))
                        }
                    </ul>
                )
            }

        </FieldShell>
    );
};
